var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":_vm.name,"appear":_vm.appear}},[(_vm.isVisible)?_c('div',{style:({ animationDuration: (_vm.duration + "s"), transitionDuration: (_vm.duration + "s") })},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }